import { createSelector } from 'reselect';

const defaultI18n = {
  t: (key) => key // Default implementation that just returns the key
};

// Stable default object to prevent unnecessary re-renders
const EMPTY_OBJECT = {};

export const selectCommonState = (state) => state.common || {};
export const selectI18n = (state) => 
  state.common ? state.common.i18n : null;
export const selectIsBillingLive = (state) => selectCommonState(state).isBillingLive;
export const selectIsAppLoading = (state) => 
  state.common ? state.common.isAppLoading : false;
export const selectSnackMessage = (state) => 
  state.common ? state.common.message : null;
export const selectIsDemoMode = (state) => 
  state.common ? state.common.isDemoMode : false;

// Memoized selectors that return stable references for objects
export const selectLoadingModule = createSelector(
  [selectCommonState],
  (commonState) => commonState.loadingModule || EMPTY_OBJECT
);

export const selectLoadingModules = createSelector(
  [selectCommonState], 
  (commonState) => commonState.loadingModules || EMPTY_OBJECT
);

// selectIsAuthStateLoading has been moved to auth slice
// Re-export from auth selectors for backward compatibility
export { selectIsAuthLoading as selectIsAuthStateLoading } from '../auth/selectors';
